import { createEffect, onCleanup } from 'solid-js';
import {
  clearAssistantPageDetails,
  setAssistantPageDetails,
  type AssistantPageDetails,
} from '../store/assistantContextStore';

/**
 * Publish page-specific Capitan ask context while this page is mounted.
 * `details` may be a getter so it stays reactive.
 */
export function useAssistantPageScope(details: () => AssistantPageDetails): void {
  createEffect(() => {
    setAssistantPageDetails(details());
  });
  onCleanup(() => {
    clearAssistantPageDetails();
  });
}
